export const WIZARD_EMAIL_DOMAINS = ['joinwaterlily.com', 'aterlily.com'] as const;

export function isWizardEmail(email: string | null | undefined) {
  const normalizedEmail = email?.trim().toLowerCase();

  return Boolean(
    normalizedEmail && WIZARD_EMAIL_DOMAINS.some(domain => normalizedEmail.endsWith(`@${domain}`)),
  );
}

export function isWizard(
  advisor: Pick<Advisor, 'advisorEmail' | 'featureFlags'> | null | undefined,
) {
  return Boolean(isWizardEmail(advisor?.advisorEmail) || advisor?.featureFlags?.wizardMode);
}
